<template>
    <div>
        <Wp_nav_bar title="我的总预估收入详情(拼多多)" :has-click="true" @click="clickToBack"></Wp_nav_bar>
        <Wp_pdd_order_count_detail_model></Wp_pdd_order_count_detail_model>
    </div>
</template>

<script>
    import Wp_nav_bar from "../../custom/Wp_nav_bar";
    import Wp_pdd_order_count_detail_model from "./Wp_pdd_order_count_detail_model";
    export default {
        name: "Wp_pdd_order_count_detail_page",
        components: {Wp_pdd_order_count_detail_model, Wp_nav_bar},

        methods:{
            clickToBack(){
                this.$common_pdd.back_from_count_new = true;
                this.$router.back();
            }
        }
    }
</script>

<style scoped>

</style>